import { useStaticQuery, graphql } from 'gatsby';

const useHome = () => {
  const results = useStaticQuery(
    graphql`
      query Home {
        paperformHelpHome {
          meta {
            meta_description
            meta_image
            meta_title
            og_title
            og_description
          }
          content {
            ...ComponentsFragment
          }
        }
      }
    `,
  );

  const { paperformHelpHome } = results;

  return paperformHelpHome;
};

export default useHome;
